import { createSlice } from "@reduxjs/toolkit";
import { GALLERY } from "../../db/data";

const initialState = { gallery:[] };
const gallerySlice = createSlice({
    name: "gallery",
    initialState,
    reducers : {
        loadGallery: (state,action) => {
            state.gallery = GALLERY;
        },
        addGallery: (state,action) => {
            state.gallery.push(action.payload);
        }
    }
});

//export slice reducer and action creators
export default gallerySlice.reducer;
export const { loadGallery, addGallery } = gallerySlice.actions;

//export state slice
export const selectGallery = state => state.gallery ; 